import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { Link } from "react-router-dom";

import {
  DATA_EXPLORER_PAGE_TITLE,
  DATA_EXPLORER_ROUTE,
} from "@helpers/constants";

const StyledDiv = styled("div")({
  display: "grid",
  gridAutoFlow: "column",
  gap: "1rem",
  justifyContent: "start",
  alignItems: "baseline",
  "& a": { textDecoration: "none" },
});

const SiteTitle = (props: { subtitle?: React.ReactNode }) => {
  return (
    <StyledDiv>
      <Link to={DATA_EXPLORER_ROUTE}>
        <Typography variant="h2" color="primary">
          {DATA_EXPLORER_PAGE_TITLE}
        </Typography>
      </Link>
      {props.subtitle && props.subtitle}
    </StyledDiv>
  );
};

export default SiteTitle;
